module.exports = __webpack_public_path__ + "static/img/yj01.64ec039.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/yj01.jpeg
// module id = 774K
// module chunks = 2